import { Box, Typography } from '@mui/material';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import { PromptModel } from 'api/model';
import LLMIcon from 'components/LLMIcon/LLMIcon';
import { useStore } from 'store/store';

type ModelRendererProps = {
  modelId: string;
  models: PromptModel[];
};

const ModelRenderer = ({ modelId, models }: ModelRendererProps) => {
  const offlineMode = useStore().offlineMode;
  const model = models?.find((m) => m.id === modelId);

  if (!model) return <span>{modelId}</span>;

  const showOfflineWarning = offlineMode && !model.is_local;

  return (
    <Box display="flex" gap={2} alignItems="center" justifyContent="space-between" width="100%">
      <Box display="flex" gap={1} alignItems="center" className="flex">
        <LLMIcon size={18} provider={model.type} model={model.settings?.model} />
        <span>{model.name}</span>
        {showOfflineWarning && (
          <Box display="flex" gap={0.5} alignItems="center" className="text-amber-600 dark:text-amber-400">
            <CloudOffIcon sx={{ fontSize: 14 }} />
            <Typography variant="caption">Unavailable in offline mode</Typography>
          </Box>
        )}
      </Box>
      <LLMIcon size={14} provider={model.type} />
    </Box>
  );
};

export default ModelRenderer;
